export enum StorageKey {
  ShareHintSeen = 'hintSeen.share',
  WhatsNewLastSeenVersion = 'whatsNew.lastSeenVersion',
}

export function validateStorageKeys(): void {
  const keys = Object.values(StorageKey)
  if (keys.some((key) => !key.trim()) || new Set(keys).size !== keys.length) {
    throw new Error('Browser storage keys must be non-empty and unique')
  }
}
